import React from 'react'

import { Box, Typography } from "@mui/material"
import { IconSeeker } from '@ui-seeker/core'

export default function actionColumn() {

	const statusColors = {
		catalog: 'error.main',
		stock: 'warning.main',
	}

	const statusIcons = {
		catalog: 'xmark',
		stock: 'hourglass',
	}

	const textMapper = {
		catalog: 'Action needed in Amazon Catalog',
		stock: 'Stock needed at Amazon',
	}

	return [{
		name: 'action',
		label: 'Actions',
		options: {
			display: 'excluded',
			customBodyRowRender: value => textMapper[value]
		}
	}, {
		name: 'action',
		label: 'Actions',
		options: {
			filter: false,
			customBodyRowRenderLite: value => (
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mr: '8px' }}>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							p: 1,
							gap: 1,
							backgroundColor: statusColors[value],
							borderRadius: "12px",
							minWidth: "100px",
							maxWidth: "200px",
						}}
					>
						<IconSeeker iconWeight='solid' icon={statusIcons[value]} sx={{ color: "white", fontSize: 12 }} />
						<Typography sx={{ fontWeight: "bold", color: "white", fontSize: '12px' }}>
							{textMapper[value]}
						</Typography>
					</Box>
				</Box>
			)
		}}
	]
}
